// extracted by mini-css-extract-plugin
module.exports = {"cover":"ContentBlock_cover__2hxBO","header":"ContentBlock_header__1_ANu","wrap":"ContentBlock_wrap__1ZQEK","descr":"ContentBlock_descr__347Ls"};